/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:63e04cca-6f56-4f46-8193-684cfa3fd18b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_SZ6A6pzU7",
    "aws_user_pools_web_client_id": "7g70tnuo5nqnmip6t7e98jsblb",
    "oauth": {
        "domain": "upstreamcee5373f6-ee5373f6-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://upst.cranial.cloud/signin/",
        "redirectSignOut": "https://upst.cranial.cloud/signout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://74coqxpxek.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://qytlugmlr5dodglwev4yfo5pxe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-td42ychj5be35ksjq6ldvopj5e"
};


export default awsmobile;
